// Adapter para la API de KPIs de mercancía
// Merchandise KPIs API adapter

import { apiClientWH } from '@shared/services/ApiClient';

export interface MerchandiseItem {
  name: string;
  code: string;
  image: string;
  qty: number;
  image_url: string;
}

export interface MerchandiseKpisData {
  merchandise_list: MerchandiseItem[];
  merchandise_sum: number;
  merchandise_count: number;
}

export interface MerchandiseKpisResponse {
  success: boolean;
  data: MerchandiseKpisData;
  message: string;
}

export interface MerchandiseKpisParams {
  date?: string; // Y-m-d format
}

export class MerchandiseKpisApiAdapter {
  constructor(private httpClient: typeof apiClientWH) {}

  /**
   * GET /report/merchandise-kpis
   * Parámetros:
   * - date (opcional): Date to filter merchandise receptions (Y-m-d format). Defaults to today
   */
  async getMerchandiseKpis(params: MerchandiseKpisParams = {}): Promise<MerchandiseKpisResponse> {
    const response = await this.httpClient.get('/report/merchandise-kpis', {
      params: {
        date: params.date,
      },
    });

    return response.data;
  }
}
